module.exports = __webpack_public_path__ + "static/media/IMG_5437.9d61565d.JPG";